import type { Option } from "common/blocks/DropdownInput";

export interface SORT_OPTIONS_TYPE {
    title: string;
    values: Option[];
}

export const DEFAULT_SORT_OPTION: Option = {
    label: "Added to shortlist: Newest to oldest",
    value: "shortlistTimestampDesc",
};

export const SHORTLIST_SORT_OPTIONS: SORT_OPTIONS_TYPE[] = [
    {
        title: "Added to shortlist",
        values: [
            {
                label: "Added to shortlist: Newest to oldest",
                value: "shortlistTimestampDesc",
            },
            {
                label: "Added to shortlist: Oldest to newest",
                value: "shortlistTimestampAsc",
            },
        ],
    },
    {
        title: "Monthly Cost",
        values: [
            {
                label: "Monthly cost: Lowest to highest",
                value: "LowestFinanceOptionAsc",
            },
            {
                label: "Monthly cost: Highest to lowest",
                value: "LowestFinanceOptionDesc",
            },
        ],
    },
    {
        title: "Price",
        values: [
            {
                label: "Price: Lowest to highest",
                value: "CurrentPriceAsc",
            },
            {
                label: "Price: Highest to lowest",
                value: "CurrentPriceDesc",
            },
        ],
    },
    {
        title: "Mileage",
        values: [
            {
                label: "Mileage: Lowest to highest",
                value: "MileageAsc",
            },
            {
                label: "Mileage: Highest to lowest",
                value: "MileageDesc",
            },
        ],
    },
];

export const SAVED_SEARCHES_SORT_OPTIONS: Option[] = [
    {
        label: "Newest to oldest",
        value: "createdAt:desc",
    },
    {
        label: "Oldest to newest",
        value: "createdAt:asc",
    },
    {
        label: "Alphabetical (A-Z)",
        value: "name:asc",
    },
    {
        label: "Alphabetical (Z-A)",
        value: "name:desc",
    },
];

export const SAVED_SEARCHES_DEFAULT_SORT_OPTION: Option = SAVED_SEARCHES_SORT_OPTIONS[0];

export const VEHICLES_PER_PAGE = 40;
export const SEARCHES_PER_PAGE = 40;
